import { createColumnHelper } from "@tanstack/react-table";
import React from "react";
import { IoMdStar } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import Table from "../../../../../components/ui/Table/Table";
import { formatDateTime, indexer } from "../../../../../utils";

const columnHelper = createColumnHelper();

const columns = (page, pageSize, total, navigate) => {
  return [
    columnHelper.accessor((row) => row, {
      header: "번호",
      cell: (info) => {
        const index = info.cell.row.index;
        const indexing = indexer(page, pageSize, total);

        return <div>{indexing(index)}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.images, {
      header: "구분",
      cell: (info) => {
        const val = info.getValue();
        const type = val?.length > 0 ? "photo" : "general";

        return (
          <div>
            {val ? (type === "photo" ? "포토 리뷰" : "일반 리뷰") : "-"}
          </div>
        );
      },
    }),

    columnHelper.accessor((row) => row?.enrollmentStatus, {
      header: "등록 상태",
      cell: (info) => {
        const val = info.getValue();
        const translated = () => {
          switch (val) {
            case "NORMAL":
              return "정상 등록";
            case "REPORT":
              return "신고 상태";
            case "HIDDEN":
              return "숨김 상태";
            default:
              return "";
          }
        };
        return <div>{val ? translated() : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.hospitalMember?.hospital?.name, {
      header: "작성자",
      cell: (info) => {
        const val = info.getValue();
        return <div>{val ? val : "-"}</div>;
      },
    }),
    columnHelper.accessor((row) => row?.productGroup, {
      header: "관련 상품명",
      cell: (info) => {
        const val = info.getValue()?.name;
        const id = info.getValue()?.id;
        const productGroupName =
          val?.length > 15 ? val?.substring(0, 35) + "..." : val;
        return (
          <div
            onClick={() => navigate(`/product-management/product-group/${id}`)}
            className="underline cursor-pointer"
          >
            {val ? productGroupName : "-"}
          </div>
        );
      },
    }),

    columnHelper.accessor((row) => row?.rate, {
      header: "평점",
      cell: (info) => {
        const val = info.getValue();
        return (
          <div className="text-center">
            {val ? (
              <div className="flex justify-center items-center gap-1">
                {Array.from({ length: 5 }).map((_, index) => {
                  return (
                    <IoMdStar
                      key={index}
                      className={`text-lg ${
                        index + 1 < val + 1
                          ? "text-[#f2dca8]"
                          : "text-[#aaaaaa]"
                      }`}
                    />
                  );
                })}
              </div>
            ) : (
              "-"
            )}
          </div>
        );
      },
    }),

    columnHelper.accessor((row) => row?.contents, {
      header: "내용",
      cell: (info) => {
        const val = info.getValue();
        const contents = val?.length > 15 ? val?.substring(0, 35) + "..." : val;

        return <div>{val ? contents : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.createdAt, {
      header: "등록일시(숨김일시)",
      cell: (info) => {
        const val = info.getValue();
        return <div>{val ? formatDateTime(val) : "-"}</div>;
      },
    }),

    columnHelper.display({
      header: "자세히보기",
      id: "actions",
      cell: ButtonActions,
    }),
  ];
};

function ButtonActions(props) {
  const id = props.row.original?.id;
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => navigate(`${id}`)}
      className="w-10 p-[1px] border border-[#cccccc] rounded-[4px] text-[#333333]"
    >
      확인
    </button>
  );
}

const sorts = [
  { id: "CREATED_AT_DESC", name: "최신순" },
  { id: "RATE_DESC", name: "평점 높은 순" },
  { id: "", name: "평점 낮은 순" },
  { id: "", name: "등록일시 순" },
  { id: "", name: "숨김일시 순" },
];
export function HospitalReviewTable(props) {
  const { getDataTableProps, isEmpty, onSort } = props;
  const currentPage = getDataTableProps().pagination?.pageIndex + 1;
  const pageSize = getDataTableProps().pagination?.pageSize;
  const totalData = getDataTableProps().total;
  const navigate = useNavigate();

  return (
    <>
      {isEmpty ? (
        <div className="flex justify-center mt-[60px] text-[#999999] text-center text-[14px]">
          등록된 내역이 없습니다.
        </div>
      ) : (
        <Table
          hasSave={false}
          hasPageSizeFilter={false}
          sorts={sorts}
          onSort={onSort}
          width="w-26"
          columns={columns(currentPage, pageSize, totalData, navigate)}
          {...getDataTableProps()}
        />
      )}
    </>
  );
}
